// extracted by css-extract-rspack-plugin
export default {"breathe":"breathe-HYfDLo"};